<template>
  <base-modal :id="id" :close-visible="false">
    <template v-if="finishedLoading">
      <h5 class="text-center">{{ $t('notificationPanel.title') }}</h5>

      <notification-preference-partial
        :record="currentMember"
        :scoped-notification-preference="scopedHealthPreference"
        :notification-preference="healthPreference"
        :organization-scope="defaultOrganization"
        :show-timezone-select="true"
      />

      <div class="cta-btns">
        <b-button @click="closeThisModal">Cancel</b-button>
        <b-button @click="closeThisModal">Save</b-button>
      </div>
    </template>
    <spinner v-else />
  </base-modal>
</template>

<script>
import commonFunctions from '@/mixins/common';
import notificationPreferences from '@/mixins/notification-preferences';
import MemberService from '@/services/member.service';
import {mapState} from "vuex";

export default {
  name: 'notification-panel',
  mixins: [commonFunctions, notificationPreferences],
  components: {
    BaseModal: () => import('@/components/base-modal/base-modal.vue'),
    Spinner: () => import('@/components/loading-spinner/loading-spinner'),
    NotificationPreferencePartial: () => import('@/components/notification-preference-partial/notification-preference-partial'),
  },
  data() {
    return {
      id: 'notification-panel-modal',
      healthPreference: null,
      scopedHealthPreference: null,
      user: null,
      member: null,
      debugLog: false,
    };
  },
  computed: {
    ...mapState(['defaultOrganization', 'currentMember']),
  },
  mounted() {
    this.log('NotificationPanel -> Mounted', '');
    this.initialLoad();
  },
  methods: {
    reset() {
      this.user = null;
      this.member = null;
      this.healthPreference = null;
      this.scopedHealthPreference = null;
    },
    initialLoad() {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const outterParams = {timestamp: secondsSinceEpoch};
      this.reset();
      // Current user is in COMMON
      if (this.currentMember) {
        this.log('NotificationPanel -> initialLoad', 'currentMember', this.currentMember);
        MemberService.show(this.currentMember.id, outterParams).then(({ data }) => {
          this.log('NotificationPanel -> initialLoad -> MemberService.show', 'data', data);
          this.member = data;
          return this.findHealthNotification(this.currentMember.id, 'V2::Member');
        })
        .then((res) => {
          this.log('NotificationPanel -> initialLoad -> findHealthNotification', 'res', res);
          this.scopedHealthPreference = this.member.attributes.health_notification_preference;
          this.healthPreference = res;
          this.finishedLoading = true;
        });
      }
    },
    closeThisModal() {
      this.closeModal(this.id);
      setTimeout(() => {
        this.initialLoad();
      }, 250);
    },
  },
};
</script>

<style scoped lang="scss" src="./style.scss">

</style>
